import { Trans, t } from "@lingui/macro";
import RecoverySourceConfirmDrawer from "./RecoverySourceConfirmDrawer";

type RecoverySourceChangeDrawerProps = {
  // Undefined when the active source isn't in the visible list (capability revoked, or Apple
  // Health behind its flag), so the copy can't name it.
  currentSourceName?: string;
  newSourceName: string;
  // The new source is Apple Health, the HRV source (TAJ-1628); every other provider keeps the
  // recovery wording.
  appleHealth?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// Confirmation before one recovery source replaces another.
const RecoverySourceChangeDrawer = ({
  currentSourceName,
  newSourceName,
  appleHealth = false,
  onConfirm,
  onCancel,
}: RecoverySourceChangeDrawerProps) => (
  <RecoverySourceConfirmDrawer
    title={
      appleHealth ? (
        <Trans>Changing HRV data source</Trans>
      ) : (
        <Trans>Changing recovery data source</Trans>
      )
    }
    body={
      currentSourceName
        ? t`Changing your data source will deactivate ${currentSourceName} and ${newSourceName} will become your new source. To avoid recalibrating your recovery response, be sure to have enough calibrated data in ${currentSourceName}.`
        : t`Changing your data source will deactivate your current source and ${newSourceName} will become your new source. To avoid recalibrating your recovery response, be sure to have enough calibrated data in your current source.`
    }
    confirmLabel={
      appleHealth ? (
        <Trans>Change HRV data source</Trans>
      ) : (
        <Trans>Change recovery data source</Trans>
      )
    }
    cancelLabel={<Trans>Cancel</Trans>}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default RecoverySourceChangeDrawer;
